import gql from "graphql-tag";

import { FRAGMENT_USER_ALL_FIELDS } from "../../../graphql/gqlFragments";

export const UPDATE_USER_EMAIL = gql`
  mutation updateUser($email: String!, $currentPassword: String!) {
    updateUser(email: $email, currentPassword: $currentPassword) {
      user {
        id
        email
        unconfirmedEmail
      }
      accessToken
    }
  }
`;

export const CHECK_USER_LOGIN = gql`
  query checkLogin($login: String!) {
    checkLogin(login: $login) {
      isExist
    }
  }
`;

export const CONFIRM_USER_EMAIL = gql`
  mutation confirmUserEmail($confirmationToken: String!) {
    confirmUserEmail(confirmationToken: $confirmationToken) {
      user {
        ...UserAllFields
      }
      accessToken
      needRedirect
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;
